import { useMemo } from 'react';
import { useLocation } from 'react-router-dom';
import { useAppSelector } from '../../redux';
import * as UserRedux from '../../redux/user';
import { equalsIgnoreCase } from '../text-utils';

export const getCompanySlug = (pathname: string): string => pathname.split('/')[1] ?? '';

// Returns null when the companies list has not yet loaded from Redux.
// Returns '' when companies are loaded but the URL has no company segment (global route).
// Returns the matched company slug when on a client route.
export const useLocationCompany = (): string | null => {
  const { pathname } = useLocation();
  const companies = useAppSelector(UserRedux.companiesSelector);
  // Extract only the first path segment so the memo only invalidates on company change,
  // not on every sub-path navigation (e.g. tab switches within the same page).
  const companySlug = getCompanySlug(pathname);

  return useMemo(() => {
    if (companies.length === 0) return null;
    return companies.find(c => equalsIgnoreCase(c.company, companySlug))?.company ?? '';
  }, [companySlug, companies]);
};
